import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Navbar from 'react-bootstrap/lib/Navbar';

import ErrorPage from '../error-page';
import FullLogo from '../logo/logo--full';
import { bugsnagNotify, dumpReduxState } from '../../util';
import { researcherErrorRegistry } from '../../redux/error-registry';
import ErrorModal from './error-modal';
import ErrorMessage from '../error-message';

class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    errorRegistry: PropTypes.shape(),
    state: PropTypes.shape().isRequired,
  };
  static defaultProps = {
    errorRegistry: researcherErrorRegistry,
  };
  state = {
    error: null,
  };
  componentDidCatch(error, reactDetails) {
    this.setState({ error });
    // NOTE: timezones are big and static, having them
    const { timezones, ...reduxState } = dumpReduxState(this.props.state);
    bugsnagNotify(error, {
      metadata: {
        reactDetails: JSON.stringify(reactDetails),
        reduxState: JSON.stringify(reduxState),
      },
    });
  }
  render() {
    const { error } = this.state;
    if (error) {
      return (
        <div className="container with-navigation">
          <Navbar fixedTop inverse>
            <div style={{ paddingTop: 6 }}>
              <FullLogo />
            </div>
          </Navbar>
          <br />
          <br />
          <ErrorPage>
            <ErrorMessage error={error} />
          </ErrorPage>
        </div>
      );
    }
    return (
      <Fragment>
        {this.props.children}
        <ErrorModal errorRegistry={this.props.errorRegistry} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({ state });

export default connect(mapStateToProps)(ErrorBoundary);
